import {    NgModule            } from '@angular/core';

import {    MatSliderModule     } from '@angular/material/slider';
import {    MatButtonModule     } from '@angular/material/button';
import {    MatIconModule       } from '@angular/material/icon';
import {    MatFormFieldModule  } from '@angular/material/form-field';
import {    MatInputModule      } from '@angular/material/input';
import {    MatCardModule       } from '@angular/material/card';
import {    MatDialogModule     } from '@angular/material/dialog';
import {    MatSidenavModule    } from '@angular/material/sidenav';
import {    MatListModule       } from '@angular/material/list';
import {    MatExpansionModule  } from '@angular/material/expansion';
import {    MatToolbarModule    } from '@angular/material/toolbar';
import {    MatSelectModule     } from '@angular/material/select';
import {    MatDatepickerModule } from '@angular/material/datepicker';
import {    MatRadioModule      } from '@angular/material/radio';
import {    MatCheckboxModule   } from '@angular/material/checkbox';
import {    MatNativeDateModule } from '@angular/material/core';
import {    MatMenuModule       } from '@angular/material/menu';
import {    MatChipsModule      } from '@angular/material/chips';

import {    ClipboardModule     } from '@angular/cdk/clipboard';

@NgModule ({
    exports: [
        MatSliderModule ,
        MatButtonModule ,
        MatIconModule   ,
        MatFormFieldModule,
        MatInputModule,
        MatCardModule,
        MatDialogModule,
        MatSidenavModule,
        MatListModule,
        MatExpansionModule,
        MatToolbarModule,
        MatSelectModule,
        MatDatepickerModule,
        MatRadioModule,
        MatCheckboxModule,
        MatNativeDateModule,
        MatMenuModule,
        MatChipsModule,
        ClipboardModule
    ],
    imports: [
        MatSliderModule ,
        MatButtonModule ,
        MatIconModule   ,
        MatFormFieldModule,
        MatInputModule,
        MatCardModule,
        MatDialogModule,
        MatSidenavModule,
        MatListModule,
        MatExpansionModule,
        MatToolbarModule,
        MatSelectModule,
        MatDatepickerModule,
        MatRadioModule,
        MatCheckboxModule,
        MatNativeDateModule,
        MatMenuModule,
        MatChipsModule,
        ClipboardModule
    ]
})
export class MaterialModule { }
